(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "../dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ShortcutsHelper = function () {
  function ShortcutsHelper() {
    _classCallCheck(this, ShortcutsHelper);

    this.mapFunctions = [];
    this.objAvoided = [];
    this.elementAvoided = [];
    this.keyPressed = false;
  }

  _createClass(ShortcutsHelper, [{
    key: 'init',
    value: function init(options) {
      var _this = this;

      if (options.prevent && options.prevent.isArray) {
        throw new Error('Please define options.prevent as an array');
      }
      this.elementAvoided = options && options.prevent ? options.prevent : [];
      document.addEventListener('keydown', function (event) {
        var decodedKey = _this.decodeKey(event);
        if (_this.filteringElement(decodedKey)) {
          var prevent = true;
          for (var i = 0; i < _this.mapFunctions[decodedKey].length; i++) {
            var mapFunction = _this.mapFunctions[decodedKey][i];
            if (!mapFunction.pv) {
              prevent = false;
            }
            if (mapFunction.db) {
              continue;
            }
            if (mapFunction.fn) {
              _this.keyDown(event, mapFunction, decodedKey);
              _this.keyPressed = true;
            } else if (!_this.keyPressed) {
              mapFunction.el.focus();
              _this.keyPressed = true;
            }
          }
          if (prevent) {
            event.preventDefault();
            event.stopPropagation();
          }
        }
      }, true);

      document.addEventListener('keyup', function (event) {
        var decodedKey = _this.decodeKey(event);
        if (_this.filteringElement(decodedKey)) {
          var prevent = true;
          for (var i = 0; i < _this.mapFunctions[decodedKey].length; i++) {
            var mapFunction = _this.mapFunctions[decodedKey][i];
            if (!mapFunction.pv) {
              prevent = false;
            }
            if (mapFunction.db) {
              continue;
            }
            if (mapFunction.oc || mapFunction.ps) {
              _this.keyUp(event, mapFunction, decodedKey);
            }
          }
          if (prevent) {
            event.preventDefault();
            event.stopPropagation();
          }
        }
        _this.keyPressed = false;
      }, true);
    }
  }, {
    key: 'decodeKey',
    value: function decodeKey(pKey) {
      var k = '';
      if (pKey.key === 'Shift' || pKey.shiftKey) {
        k += 'shift';
      }
      if (pKey.key === 'Control' || pKey.ctrlKey) {
        k += 'ctrl';
      }
      if (pKey.key === 'Meta' || pKey.metaKey) {
        k += 'meta';
      }
      if (pKey.key === 'Alt' || pKey.altKey) {
        k += 'alt';
      }
      if (pKey.key === 'ArrowUp') {
        k += 'arrowup';
      }
      if (pKey.key === 'ArrowLeft') {
        k += 'arrowleft';
      }
      if (pKey.key === 'ArrowRight') {
        k += 'arrowright';
      }
      if (pKey.key === 'ArrowDown') {
        k += 'arrowdown';
      }
      if (pKey.key === 'AltGraph') {
        k += 'altgraph';
      }
      if (pKey.key === 'Escape') {
        k += 'esc';
      }
      if (pKey.key === 'Enter') {
        k += 'enter';
      }
      if (pKey.key === 'Tab') {
        k += 'tab';
      }
      if (pKey.key === ' ') {
        k += 'space';
      }
      if (pKey.key === 'PageUp') {
        k += 'pageup';
      }
      if (pKey.key === 'PageDown') {
        k += 'pagedown';
      }
      if (pKey.key === 'Home') {
        k += 'home';
      }
      if (pKey.key === 'End') {
        k += 'end';
      }
      if (pKey.key && pKey.key !== ' ' && pKey.key.length === 1 || /F\d{1,2}/g.test(pKey.key)) k += pKey.key.toLowerCase();
      return k;
    }
  }, {
    key: 'keyDown',
    value: function keyDown(event, mapFunction, decodedKey) {
      if (!mapFunction.oc && !mapFunction.ps || mapFunction.ps && !this.keyPressed) {
        mapFunction.cb(event, decodedKey);
      }
    }
  }, {
    key: 'keyUp',
    value: function keyUp(event, mapFunction, decodedKey) {
      mapFunction.cb(event, decodedKey);
    }
  }, {
    key: 'filteringElement',
    value: function filteringElement(decodedKey) {
      var objectAvoid = this.objAvoided.find(function (r) {
        return r === document.activeElement;
      });
      var elementSeparate = this.checkElementType();
      var elementTypeAvoid = elementSeparate.avoidedTypes;
      var elementClassAvoid = elementSeparate.avoidedClasses;
      var filterTypeAvoid = elementTypeAvoid.find(function (r) {
        return r === document.activeElement.tagName.toLowerCase();
      });
      var filterClassAvoid = elementClassAvoid.find(function (r) {
        return r === '.' + document.activeElement.className.toLowerCase();
      });
      return !objectAvoid && this.mapFunctions[decodedKey] && this.mapFunctions[decodedKey].length && !filterTypeAvoid && !filterClassAvoid;
    }
  }, {
    key: 'checkElementType',
    value: function checkElementType() {
      var elmTypeAvoid = [];
      var elmClassAvoid = [];
      this.elementAvoided.forEach(function (r) {
        var dotPosition = r.indexOf('.');
        if (dotPosition === 0) {
          elmClassAvoid.push(r);
        } else if (dotPosition > 0) {
          elmTypeAvoid.push(r.split('.')[0]);
          elmClassAvoid.push('.' + r.split('.')[1]);
        } else {
          elmTypeAvoid.push(r);
        }
      });

      return { avoidedTypes: elmTypeAvoid, avoidedClasses: elmClassAvoid };
    }
  }, {
    key: 'findIndexOf',
    value: function findIndexOf(k, el) {
      for (var i = 0; i < this.mapFunctions[k].length; i++) {
        if (this.mapFunctions[k][i].el === el) {
          return i;
        }
      }
    }
  }]);

  return ShortcutsHelper;
}();

var shortcutsHelper = new ShortcutsHelper();
exports.ShortcutsHelper = shortcutsHelper;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shortcutsDirective = __webpack_require__(2);

var _shortcutsHelper = __webpack_require__(0);

var VueShortcuts = {};

VueShortcuts.install = function (Vue, options) {
  _shortcutsHelper.ShortcutsHelper.init(options || {});
  Vue.directive('shortcuts', _shortcutsDirective.ShortcutsDirective);
};

exports.default = VueShortcuts;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShortcutsDirective = undefined;

var _shortcutsHelper = __webpack_require__(0);

var ShortcutsDirective = {
  bind: function bind(el, binding, vnode) {
    var bindings = binding.value;
    for (var i = 0; i < bindings.length; i++) {
      if (bindings[i].avoid) {
        _shortcutsHelper.ShortcutsHelper.objAvoided.push(el);
        return;
      }
      var k = bindings[i].shortcut.join('');
      if (!_shortcutsHelper.ShortcutsHelper.mapFunctions[k]) {
        _shortcutsHelper.ShortcutsHelper.mapFunctions[k] = [];
      }
      _shortcutsHelper.ShortcutsHelper.mapFunctions[k].push({
        'ps': bindings[i].push === true,
        'oc': bindings[i].once === true,
        'fn': !(bindings[i].focus === true),
        'db': bindings[i].disabled || false,
        'pv': bindings[i].prevent === false ? false : true,
        'cb': bindings[i].callback,
        'el': vnode.elm
      });
    }
  },
  unbind: function unbind(el, binding) {
    var bindings = binding.value;
    for (var i = 0; i < bindings.length; i++) {
      if (bindings[i]) {
        var k = bindings[i].shortcut.join('');
        _shortcutsHelper.ShortcutsHelper.mapFunctions[k].splice(_shortcutsHelper.ShortcutsHelper.findIndexOf(k, el), 1);
      }
    }
    for (var j = 0; j < _shortcutsHelper.ShortcutsHelper.objAvoided.length; j++) {
      if (_shortcutsHelper.ShortcutsHelper.objAvoided[j] === el) {
        _shortcutsHelper.ShortcutsHelper.objAvoided.splice(j, 1);
        break;
      }
    }
  },
  update: function update(el, binding, vnode) {
    var bindings = binding.value;
    for (var i = 0; i < bindings.length; i++) {
      var k = bindings[i].shortcut.join('');
      _shortcutsHelper.ShortcutsHelper.mapFunctions[k][_shortcutsHelper.ShortcutsHelper.findIndexOf(k, el)].db = bindings[i].disabled || false;
    }
  }
};

exports.ShortcutsDirective = ShortcutsDirective;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js